import type { NavigateToOptions } from '#app/composables/router'
import type { SupportedLocales } from '#i18n/types'
import type { RouteLocationRaw } from '#vue-router'

export const useNavigateToLocalized = () => {
  const localePath = useLocalePath()

  const navigateToLocalized = (
    to: RouteLocationRaw,
    options?: NavigateToOptions,
    locale?: SupportedLocales['code'],
  ) => navigateTo(localePath(to, locale), options)

  return { navigateToLocalized }
}
